'use client';

import { motion } from 'framer-motion';
import ContactInfo from '../contact/ContactInfo';
import ContactForm from '../contact/ContactForm';
import { InformativeTag } from '../ui/custom/InformativeTag';

const Contact = () => {
  return (
    <div className="relative min-h-screen page-gradient overflow-hidden">
      {/* <div className="relative min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 overflow-hidden"> */}
      {/* Floating background elements */}
      <div className="absolute inset-0">
        <motion.div
          animate={{
            y: [0, -20, 0],
            rotate: [0, 5, 0],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="absolute top-20 left-10 w-32 h-32 bg-green-100 rounded-full opacity-20 blur-xl"
        />
        <motion.div
          animate={{
            y: [0, 30, 0],
            rotate: [0, -5, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="absolute bottom-20 right-20 w-40 h-40 bg-orange-100 rounded-full opacity-20 blur-xl"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-20">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20 space-y-8">
          <div className="space-y-6">
            <InformativeTag>Get in Touch</InformativeTag>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6 tracking-tight leading-tight">
              <span className="bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
                Contact
              </span>{' '}
              Us
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-amber-500 mx-auto rounded-full mb-6"></div>
          </div>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light leading-relaxed">
            Have questions about our services, catering options, or want to share feedback? We&apos;d love to hear from
            you!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col-reverse lg:grid lg:grid-cols-[1fr_3fr] gap-12">
          <ContactInfo />
          <ContactForm />
        </motion.div>

        {/* Decorative elements */}
        <motion.div
          animate={{
            rotate: [0, 360],
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="absolute top-40 right-20 w-16 h-16 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full opacity-20 blur-sm"
        />

        <motion.div
          animate={{
            y: [0, -10, 0],
            opacity: [0.3, 0.6, 0.3],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="absolute bottom-20 left-20 w-20 h-20 bg-gradient-to-br from-orange-400 to-amber-500 rounded-full opacity-30 blur-lg"
        />
      </div>
    </div>
  );
};

export default Contact;
